module.exports = __webpack_public_path__ + "img/sunlei_2.3aba2972.png";